/**
 * Alarm-volume reads for sites. The per-site excessive-alarm list and the
 * cross-site alarm-count rollup.
 *
 * Contains:
 * - fetchExcessiveAlarmsForSite: one site's excessive alarms
 * - fetchAlarmCounts: alarm counts across sites
 */
import apiClient from '@sophocles/http-common';

export const fetchExcessiveAlarmsForSite = siteId =>
  apiClient.get(`sites/${siteId}/excessivealarms/`).then(res => res.data);

export const fetchAlarmCounts = (params = {}) => apiClient.get('/sites/alarmcounts/', { params }).then(res => res.data);
